module.exports = __webpack_public_path__ + "static/media/share.11c0b031.svg";